<dx-text-box
  [value]="value"
  mask="00 Aa (tt mm)"
  [maskRules]="rules"
  [inputAttr]="{ 'aria-label': 'Mask' }"
  (onValueChanged)="onValueChanged($event)">
</dx-text-box>
